/* eslint-disable eslint-comments/disable-enable-pair */
/* eslint-disable @typescript-eslint/camelcase */
/* eslint-disable jsdoc/require-example */
import React from 'react';
import defaultImg from '../../assets/img-error.svg';

export const PLATFROM_TYPE_WEB: { [key: number]: string } = {
  1: 'amazon.com',
  2: 'yahoo.com',
  3: 'rakuten.com',
  4: 'internal.com',
};

export interface GoodsCardData {
  /**
   * 商品外部 id
   */
  external_id: string;
  /**
   * 商品 url, 注意不是 图像url
   */
  href: string;
}

interface GoodsCardPropType {
  external_id: string;
  href: string;
  name: string;
  origin: string;
  imgUrl: string;
  description: string;
  onGoodsClick: (data: GoodsCardData) => void;
  onGoodsImpression: (data: GoodsCardData) => void;
}

/**
 * 传出去的信息，用于上报埋点
 */
interface GoodsCardStateType {
  /**
   * img 中 src 的地址，写成变量的原因是考虑到请求失败后兜底
   */
  imgURL: string;
}

export class GoodsCard extends React.Component<
  GoodsCardPropType,
  GoodsCardStateType
> {
  /**
   * 外层 div 的 ref
   */
  divRef: React.RefObject<HTMLDivElement> = React.createRef();

  /**
   * 用于观察是否进入视窗
   */
  observer: IntersectionObserver | null = null;

  state: GoodsCardStateType = {
    imgURL: this.props.imgUrl,
  };

  componentDidMount() {
    this.observeElement(this.divRef.current);
  }

  componentWillUnmount() {
    this.unobserveElement(this.divRef.current);
  }

  /**
   * 观察当前卡片
   * 如果进入视窗，则触发一次 onGoodsImpression
   */
  observeElement = (ref: HTMLDivElement | null) => {
    if (!ref) {
      return;
    }

    const { onGoodsImpression, external_id, href } = this.props;

    this.observer = new IntersectionObserver(
      entries => {
        const { isIntersecting } = entries[0];
        // 进入视窗
        if (isIntersecting && onGoodsImpression) {
          onGoodsImpression({ external_id, href });
        }
      },
      { root: null },
    );
    this.observer.observe(ref);
  };

  /**
   * 不再观察当前卡片
   */
  unobserveElement = (ref: HTMLDivElement | null) => {
    if (!ref || !this.observer) {
      return;
    }
    this.observer.unobserve(ref);
  };

  /**
   * 点击卡片的情况
   *
   * @param e - 点击事件
   */
  handleGoodsClick: (e: React.MouseEvent) => void = e => {
    // 拦截 a 标签的点击操作
    // 从而转化为 onGoodsClick 中的事件
    e.preventDefault();
    const { onGoodsClick, external_id, href } = this.props;
    if (onGoodsClick && typeof onGoodsClick === 'function') {
      onGoodsClick({ external_id, href });
    }
  };

  /**
   * 如果图像请求失败
   */
  handleImgError: () => void = () => {
    this.setState({
      imgURL: defaultImg,
    });
  };

  render() {
    const { external_id, href, name, imgUrl, description, origin } = this.props;
    const { imgURL } = this.state;
    return (
      <div
        className={'goods-card'}
        ref={this.divRef}
        data-url={href}
        data-name={name}
        data-origin={origin}
        data-description={description}
        data-image-url={imgUrl}
        data-external-id={external_id}>
        <a
          href={href}
          className="image" // 规避转码逻辑
          target="_blank"
          onClick={this.handleGoodsClick}></a>
        <div className="goods-card-img">
          <img src={imgURL} onError={this.handleImgError} />
        </div>
        <div className="goods-card-content">
          <div className="goods-card-content-text">{name}</div>
          <div className="goods-card-content-website">
            <span className="goods-card-content-website-icon"></span>
            <span className="goods-card-content-website-text">
              {PLATFROM_TYPE_WEB[origin]}
            </span>
          </div>
        </div>
      </div>
    );
  }
}
